import './style.scss';

export function resources_archive_block() {
    const block = document.querySelector('.resources_archive_block');
    if (!block) return;


        const form = document.querySelector('.filters.filter-wrapper');
        if (!form) return;

        const counterEl = form.querySelector('.submit-button span');
        if (!counterEl) return;

        const inputs = form.querySelectorAll(
            'input[type="checkbox"][name="resource-type[]"], input[type="checkbox"][name="topic[]"]'
        );

        const updateCount = () => {
            const count = Array.from(inputs).filter(i => i.checked).length;
            counterEl.textContent = `(${count})`;
        };

        form.addEventListener('change', (e) => {
            if (e.target.matches('input[type="checkbox"]')) updateCount();
        });

        updateCount();

}
